/**
 * Budget overview card — pie + total / spent / left + progress %.
 */
import React from 'react';
import { Card } from '../ui/card';
import { Wallet } from 'iconoir-react';
import SummaryPie from './SummaryPie';
import { formatCurrency } from './constants';

export default function BudgetSummaryCard({ summary, currency }) {
  const total = summary?.total_budget || 0;
  const spent = summary?.total_spent || 0;
  const left = summary?.remaining || 0;
  const progress = total > 0 ? (spent / total) * 100 : 0;

  return (
    <Card className="card-surface p-6" data-testid="budget-overview-card">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-serif text-xl text-charcoal">Budget</h2>
        <Wallet className="w-5 h-5 text-muted" strokeWidth={1.5} />
      </div>
      <div className="flex items-center gap-4">
        <SummaryPie filled={spent} remaining={left} filledColor="#D1B0AB" />
        <div className="flex-1 space-y-2">
          <div>
            <p className="text-xs text-muted">Total Budget</p>
            <p className="font-mono text-xl text-charcoal" data-testid="total-budget">
              {formatCurrency(total, currency)}
            </p>
          </div>
          <div className="flex gap-4">
            <div>
              <p className="text-xs text-muted">Spent</p>
              <p className="font-mono text-sm text-terracotta" data-testid="total-spent">
                {formatCurrency(spent, currency)}
              </p>
            </div>
            <div>
              <p className="text-xs text-muted">Left</p>
              <p className="font-mono text-sm text-moss" data-testid="remaining-budget">
                {formatCurrency(left, currency)}
              </p>
            </div>
          </div>
          <p className="font-mono text-xs text-muted">{progress.toFixed(0)}% used</p>
        </div>
      </div>
    </Card>
  );
}
